import { useEffect } from 'react';
import Bugsnag from '../utils/bugsnag';

export default error => {
  useEffect(() => {
    if (error) Bugsnag.notify(error);
  }, [error]);
};
